import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { write } from "xlsx";

function ChangeUrl() {
    const [formData, setFormData] = useState({
        old_url: "",
        new_url: "",
    });

    const [loading, setLoading] = useState(false);
    const [urls, setUrls] = useState([]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.old_url || !formData.new_url) {
            toast.error("Both URLs are required");
            return;
        }

        if (formData.old_url === formData.new_url) {
            toast.error("Old URL and New URL cannot be same");
            return;
        }

        try {
            setLoading(true);

            const token = localStorage.getItem("adminAuth");

            await axios.post(
                `${process.env.REACT_APP_BASEURL}/product/old_change-url/`,
                formData,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                }
            );

            toast.success("URL updated successfully!");
            fetchUrls();
            setFormData({
                old_url: "",
                new_url: "",
            });
        } catch (error) {
            console.error(error);
            toast.error(
                error?.response?.data?.message || "Something went wrong"
            );
        } finally {
            setLoading(false);
        }
    };

    const fetchUrls = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BASEURL}/product/old_change-url/`)
            console.log(res.data)
            setUrls(res?.data)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        fetchUrls();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure?")) return;

        try {
            const token = localStorage.getItem("adminAuth");

            await axios.delete(
                `${process.env.REACT_APP_BASEURL}/product/old_change-url/${id}/`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                }
            );

            toast.success("URL deleted");
            setUrls((prev) => prev.filter((u) => u.id !== id));
        } catch (error) {
            toast.error("Failed to delete URL");
        }
    };

    return (
        <>
            <div className="max-w-xl mx-auto bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-xl font-semibold mb-4">Change URL</h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Old URL */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Old URL
                        </label>
                        <input
                            type="text"
                            name="old_url"
                            placeholder="/old-page-url"
                            value={formData.old_url}
                            onChange={handleChange}
                            className="mt-1 w-full border px-4 py-2 rounded-lg focus:ring-2 focus:ring-primary-100"
                            required
                        />
                    </div>

                    {/* New URL */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            New URL
                        </label>
                        <input
                            type="text"
                            name="new_url"
                            placeholder="/new-page-url"
                            value={formData.new_url}
                            onChange={handleChange}
                            className="mt-1 w-full border px-4 py-2 rounded-lg focus:ring-2 focus:ring-primary-100"
                            required
                        />
                    </div>

                    {/* Submit */}
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-primary-200 disabled:opacity-50"
                    >
                        {loading ? "Updating..." : "Update URL"}
                    </button>
                </form>
            </div>
            <div className="overflow-x-auto">
                <h1 className="text-xl font-semibold mb-4">List of URLs</h1>

                <table className="min-w-full border border-gray-200 rounded-lg">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border">
                                S.No
                            </th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border">
                                Old URL
                            </th>
                            <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border">
                                New URL
                            </th>
                            <th className="px-4 py-2 text-center text-sm font-medium text-gray-700 border">
                                Actions
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {urls?.length > 0 ? (
                            urls.map((url, index) => (
                                <tr key={url.id || index} className="hover:bg-gray-50">
                                    <td className="px-4 py-2 border text-sm">{index + 1}</td>
                                    <td className="px-4 py-2 border text-sm">{url.old_url}</td>
                                    <td className="px-4 py-2 border text-sm">{url.new_url}</td>
                                    <td className="px-4 py-2 border text-center">
                                        {/* <button
                                            className="text-red-600 hover:underline text-sm"
                                            onClick={() => handleDelete(url.id)}
                                        >
                                            Delete
                                        </button> */}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={4}
                                    className="px-4 py-6 text-center text-gray-500"
                                >
                                    No URLs found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

        </>
    );
}

export default ChangeUrl;
